import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {
  makeGetContactCardAccount,
  makeGetContactCardIsLoading,
  makeGetContactCardPanel,
  makeGetContactCardSelectedCard,
} from '../../../store/panels/contacts/contactCard/contactCardPanelSelectors';
import {ContactCardPanelId} from '../../../store/panels/panelStateBase';
import {ContactCardHeader} from './contactCardHeader';

/*
 * Props.
 */

interface ContactCardHeaderContainerProps {
  panelId: ContactCardPanelId;
}

/*
 * Selectors.
 */

function makeGetIsAccountLoading() {
  return createSelector(
    [makeGetContactCardPanel()],
    (state) => state.accountStatus === AsyncStatusesEnum.LOADING,
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactCardHeaderContainerProps>()(() => ({
  card: makeGetContactCardSelectedCard(),
  account: makeGetContactCardAccount(),
  isLoading: makeGetContactCardIsLoading(),
  isAccountLoading: makeGetIsAccountLoading(),
}));

export const ContactCardHeaderContainer = connect(mapStateToProps)(ContactCardHeader);
